import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const ContactDetailsForm = ({
  title,
  values,
  errors,
  onChange,
  onSelectFromList,
}) => {
  return (
    <div className="label-create-address receiver customer-details">
      <div className="address-header col-12 p-0 d-flex justify-content-between flex-column flex-md-row">
        <h3 className="col-12 col-md-4 p-0">{title}</h3>
        {onSelectFromList && (
          <div className="address-actions p-0 d-flex flex-row justify-content-start align-items-center mb-3">
            <button
              type="button"
              className="link-btn"
              onClick={onSelectFromList}
            >
              Select From List
            </button>
          </div>
        )}
      </div>

      <div className="customer-details-form d-flex flex-column">
        <label
          className={`d-flex flex-column mb-3 ${errors.name ? "show-error" : ""}`}
        >
          <p className="package-prompt mb-2">
            Name<span className="text-danger">*</span>
          </p>
          <input
            value={values.name}
            onChange={(e) => onChange("name", e.target.value)}
          />
          {errors.name && <p className="text-danger">{errors.name}</p>}
        </label>

        <div className="d-flex flex-column flex-md-row gap-3">
          <label
            className={`d-flex flex-column flex-grow-1 mb-3 ${errors.email ? "show-error" : ""}`}
          >
            <p className="package-prompt mb-2">Email</p>
            <input
              value={values.email}
              onChange={(e) => onChange("email", e.target.value)}
            />
            {errors.email && <p className="text-danger">{errors.email}</p>}
          </label>
          <label
            className={`d-flex flex-column flex-grow-1 mb-3 ${errors.phone ? "show-error" : ""}`}
          >
            <p className="package-prompt mb-2">
              Phone<span className="text-danger">*</span>
            </p>
            <PhoneInput
              country="ke"
              value={values.phone}
              onChange={(phone) => onChange("phone", `+${phone}`)}
              placeholder="Enter your phone number"
              enableTerritories
            />
            {errors.phone && <p className="text-danger">{errors.phone}</p>}
          </label>
        </div>
      </div>
    </div>
  );
};

export default ContactDetailsForm;
